var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-page-content",class:{
    'is-flex': _vm.flex,
    'is-horizontal': _vm.direction === 'horizontal',
    'is-align-center': _vm.alignCenter
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }